import { Fragment } from "react";
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

import useFetch from "../../hooks/useFetch";
import { urlUserGetById } from "../../helpers";
import { CreateUserScreen } from "./CreateUserScreen";

export const EditUser = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { data } = useFetch(`${urlUserGetById}${searchParams.get('id')}`);

    return (
        <Fragment>
            {
                data
                    ? <CreateUserScreen data={data} />
                    : <CircularProgress />
            }
        </Fragment>
    )
}